module.exports = __webpack_public_path__ + "img/RiveraFullPage.a99206b2.png";